module.exports = __webpack_public_path__ + "img/ideal.0c814054.svg";